import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Button } from '@bphxd/ds-core-react';
import { EMPTY_GOC } from '../../../lib/constants';
import { TGoc } from '../../../lib/types';
import { renderOptions } from '../../../lib/util/render';
import { GOC_STATUS_ENUM } from '../../../lib/constants/dbConstants';
import { GocStatusEnum } from '../../../graph-queries/__generated__/graphql';

const GocForm: FC<{
  defaultValues?: TGoc;
  onSubmit: (goc: TGoc) => Promise<unknown>;
  onClose: () => void;
  type: 'add' | 'edit';
  isLoading?: boolean;
}> = ({ defaultValues, onSubmit, type, onClose, isLoading }) => {
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');
  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    // Prevent default behavior
    event.preventDefault();

    const data = new FormData(event.target as HTMLFormElement);
    const inputData = Object.fromEntries(data) as Record<string, string> & {
      status: GocStatusEnum;
    };

    const goc: TGoc = {
      ...EMPTY_GOC,
      ...inputData,
      jobId,
    };
    if (defaultValues?.jobId) goc.jobId = defaultValues.jobId;

    onSubmit(goc)
      .then(onClose)
      .catch((e) => {
        console.error(e);
      });
  };
  return (
    <Form className="row g-3 px-5" onSubmit={handleSubmit}>
      <div className="col-md-12">
        <FormGroup>
          <Label for="goc-status">GOC Status</Label>
          <Input
            type="select"
            name="status"
            id="goc-status"
            role="combobox"
            defaultValue={defaultValues?.status || ''}
            required
          >
            {renderOptions(GOC_STATUS_ENUM)}
          </Input>
        </FormGroup>
      </div>
      <div className="col-md-6">
        <FormGroup>
          <Label for="goc-sh1">SH1</Label>
          <Input type="text" name="sh1" id="goc-sh1" defaultValue={defaultValues?.sh1 || ''} />
        </FormGroup>
      </div>
      <div className="col-md-6">
        <FormGroup>
          <Label for="goc-mc1">MC1</Label>
          <Input type="text" name="mc1" id="goc-mc1" defaultValue={defaultValues?.mc1 || ''} />
        </FormGroup>
      </div>
      <div className="col-md-12">
        <FormGroup>
          <Label for="goc-comments" className="label-optional">
            Comments
          </Label>
          <Input
            type="textarea"
            name="comments"
            id="goc-comments"
            defaultValue={defaultValues?.comments || ''}
          />
        </FormGroup>
      </div>
      {type === 'add' ? (
        <div className="col-md-12">
          <Button
            type="submit"
            size="lg"
            className="w-100 my-4"
            theme="darker"
            level="primary"
            disabled={isLoading}
          >
            Add new goc
          </Button>
        </div>
      ) : (
        <div className="row g-3">
          <div className="col-md-6">
            <Button
              size="lg"
              className="w-100 my-4"
              theme="darker"
              level="tertiary"
              onClick={onClose}
            >
              Cancel
            </Button>
          </div>
          <div className="col-md-6">
            <Button
              type="submit"
              size="lg"
              className="w-100 my-4"
              theme="darker"
              level="primary"
              disabled={isLoading}
            >
              Save changes
            </Button>
          </div>
        </div>
      )}
    </Form>
  );
};

export default GocForm;
